import {SET_CURRENT, SET_PAGE, SET_DOC, SET_STEP, SET_INFO, SET_FINANCE, SET_LATEST, UPDATE_FORM, RESET_FORM_RESPONSE, FETCH_RESPONSE_SUCCESS} from '../actions/FormAction'

const initialState = {

    lateststep: 0,
    currentstep: 0,
    page: "createaccount",
    pagename: "Create Account",

    status: 'Pending',
    loantype: 'Installment Loan',
    legalage: 18,

    step: 0,
    infostep: 0,
    financestep: 0,
    doc: 0,

    minamt: 200,
    maxamt: 1000,
    approvedamt: 0,
    applicant: "John",
    accountnumber: '45678',

    eml: '',
    st: '',
    stt: '',
    loanamt: 500,
    askedforamt: 500,
    startapp: false,
    emailchecked: false,
    statechecked: false,
    stateserved: false,
    notserved: false,

    username: '',
    pwd: '',
    pwd2: '',
    econsent: false,
    econsent2: false,
    allchecked: false,
    allchecked2: false,
    loggedin: false,

    fn: '',
    ln: '',
    bday: '',
    tooyoung: false,
    ssn: '',
    last4ssn: '',
    phn: '',
    ismobile: false,
    ismobilechecked: false,
    receiveoffers: false,
    hasappcode: false,
    appcode: '',
    allpersonal: false,

    ismobile2: false,
    ismobilechecked2: false,
    allphonechecked: false,

    address: '',
    street: '',
    unit: '',
    city: '',
    zip: '',
    addresschecked: false,
    streetnumberchecked: false,
    streetchecked: false,
    statechanged: false,
    citychecked: false,
    zipchecked: false,

    rentorown: '',
    livinghowlong: '',

    incomesource: '',
    paymenttype: '',
    paytypefilled: false,
    paytypeold: '',
    benefittype: '',
    co: '',
    cophn: '',
    jobtitle: '',

    payfrequency: '',
    payday: '',
    payday2: '',
    weekday: '',
    lastpay: '',
    nextpay: '',
    prevpaydate: '',
    lastpaydate: '',
    nextpaydate1: '',
    nextpaydate2: '',
    payamount: '',
    otherpay: '',

    routingnum: '',
    bank: '',
    bankchecked: false,
    allbankingchecked: false,
    accounttype: '',
    bankaccount: '',

    signedinfosheet: false,
    signeddisclosure: false,
    sig1: '',
    signedagreement: false,
    sig2: '',
    signedprivacy: false,
    sig3: '',
    signedloan: false,
    sig4: '',
    signedach: false,
    sig5: '',
    agreedisclosure: false,
    agree1: '',
    agreeagreement: false,
    agree2: '',
    agreeprivacy: false,
    agree3: '',
    agreeloan: false,
    agree4: '',
    agreeach: false,
    agree5: '',

    noticedismissed: false,
    originatedmsg: false,

    principal: 475.00,
    nextduedate: '08/08/2018',
    paymentamt: 77.34,

    creditlimit: 475,
    availablecredit: 75.00,
    principalbalance: 400.00,
    lastdrawamt: 200.00,
    lastdrawdate: '08/10/2018',
    lastpaymentamt: 98.72,
    lastpaymentdate: '08/01/2018',
    nextstatementdate: '09/02/2018',

    statementdate: '09/02/2018',
    statementbal: 286.72,
    minpaymentamt: 91.68,
    paymentduedate: '09/01/2018',
    pastdue: 0.00,

    file: 'reference1.jpg',
    fileloaded: true,
    doctype: '',
    doctypechecked: false,

    eligible: true,
    indefault: false,
    previousloans: true,

    response: {}
}

const FormReducer = (state=initialState, action) => {
    switch(action.type){
        case SET_CURRENT:
            return{
                ...state,
                currentstep: action.payload
            }
        case SET_PAGE:
            return{
                ...state,
                page: action.payload
            }
        case SET_LATEST:
            return{
                ...state,
                lateststep: action.payload
            }
        case SET_STEP:
            return{
                ...state,
                step: action.payload
            }
        case SET_INFO:
            return{
                ...state,
                infostep: action.payload
            }
        case SET_FINANCE:
            return{
                ...state,
                financestep: action.payload
            }
        case SET_DOC:
            return{
                ...state,
                doc: action.payload
            }
        case UPDATE_FORM:
            return{
                ...state,
                [action.payload.stateType]: action.payload.value
            }
        case RESET_FORM_RESPONSE:
            return{
                ...state,
                response: {}
            }
        case FETCH_RESPONSE_SUCCESS:
            return{
                ...initialState,
                applicationNumber: state.applicationNumber + 1,
                response: action.payload.data,
            }
        default:
            return state;
    }
}

export default FormReducer



// WEBPACK FOOTER //
// ./src/store/reducers/FormReducer.js